var render = function render(_c,_vm){return _c('div',{staticClass:"py-3"},[_vm._v(_vm._s(_vm.props.item[_vm.props.value].name))])
}
var staticRenderFns = []

export { render, staticRenderFns }